import { CircularLoader } from '@dhis2-ui/loader';
import { theme } from '@dhis2/ui-constants';
import { IconErrorFilled24, IconWarningFilled24, IconCheckmark24 } from '@dhis2/ui-icons';
import PropTypes from 'prop-types';
import React from 'react';
export const StatusIcon = _ref => {
  let {
    error,
    warning,
    valid,
    loading
  } = _ref;

  if (error) {
    return /*#__PURE__*/React.createElement(IconErrorFilled24, {
      color: theme.error
    });
  }

  if (warning) {
    return /*#__PURE__*/React.createElement(IconWarningFilled24, {
      color: theme.warning
    });
  }

  if (valid) {
    return /*#__PURE__*/React.createElement(IconCheckmark24, {
      color: theme.valid
    });
  }

  if (loading) {
    return /*#__PURE__*/React.createElement(CircularLoader, {
      small: true
    });
  }

  return null;
};
StatusIcon.propTypes = {
  error: PropTypes.bool,
  loading: PropTypes.bool,
  valid: PropTypes.bool,
  warning: PropTypes.bool
};